import { render, staticRenderFns } from "./page-privacy_policy.vue?vue&type=template&id=4f01777c&scoped=true"
import script from "./page-privacy_policy.vue?vue&type=script&lang=js"
export * from "./page-privacy_policy.vue?vue&type=script&lang=js"
import style0 from "./page-privacy_policy.vue?vue&type=style&index=0&id=4f01777c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f01777c",
  null
  
)

export default component.exports